import { MapPin, Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0f172a] border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <h3 className="text-2xl font-medium text-[#d4af37] mb-6">JR Morales Investment Group Inc.</h3>
            <p className="text-slate-400 leading-relaxed">
              Over 30 years of excellence in real estate investment and consulting.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-medium text-[#d4af37] mb-6">Quick Links</h4>
            <div className="space-y-3">
              <Link to="/about" className="block text-slate-400 hover:text-[#d4af37] transition-colors" data-testid="footer-link-about">
                About Us
              </Link>
              <Link to="/services" className="block text-slate-400 hover:text-[#d4af37] transition-colors" data-testid="footer-link-services">
                Services
              </Link>
              <Link to="/projects" className="block text-slate-400 hover:text-[#d4af37] transition-colors" data-testid="footer-link-projects">
                Projects
              </Link>
              <Link to="/resources" className="block text-slate-400 hover:text-[#d4af37] transition-colors" data-testid="footer-link-resources">
                Resources
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-medium text-[#d4af37] mb-6">Contact Information</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3" data-testid="footer-address">
                <MapPin className="text-[#d4af37] mt-1 flex-shrink-0" size={20} />
                <span className="text-slate-400 text-sm leading-relaxed">
                  3818 Crenshaw Boulevard Suite 230<br />
                  Los Angeles, CA 90008
                </span>
              </div>
              <div className="flex items-center space-x-3" data-testid="footer-phone">
                <Phone className="text-[#d4af37] flex-shrink-0" size={20} />
                <span className="text-slate-400 text-sm">310-874-5644</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center text-slate-500 text-sm">
          <p>&copy; {new Date().getFullYear()} Jr Morales Investment Group Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}